import { Button, Typography, Box, Container } from "@mui/material"
import { useEffect, useState } from "react"
import FormulaireTicket from "../components/FormulaireTicket"
import Input from "../components/Input"
import Textarea from "../components/Textarea"
import API from "../services/API"
import { getSQLDatetimeNow } from "../services/DateHelper"

export default function Accueil({}){
    const [answers, setAnswers] = useState({nom:undefined,prenom:undefined,adresse:undefined,codePostal:undefined,ville:undefined,telephone:undefined,email:undefined,demande:undefined})
    const [answersOk, setAnswersOk] = useState(false)
    const [sent, setSent] = useState(false)

    const handleChange=(key, value)=>{
        setAnswers(currVal => ({...currVal, [key]:value}))
    }

    useEffect(()=>{
        setAnswersOk(Object.values(answers).filter(a=>a==undefined).length===0)
    },[answers])

    const handleSend=()=>{
        let date = getSQLDatetimeNow()
        answers["dateCreation"]= date
        API("POST","ticket",answers)
        .then(res=>{
            let ticketId = res.json.insertId
            API("POST","logticket",{date:date, Ticket_id:ticketId, quoi:"Ticket créé"})
            API("POST","logticket",{date:getSQLDatetimeNow(), Ticket_id:ticketId, quoi:"Statut modifié", donnee:"Brouillon"})

            setSent(true)
        })
    }

    return(
        <Container maxWidth="md">
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height:"100px", position: "relative"}}>
                <Box component="img" src="logo.png" sx={{ width: { xs: "70px", md: "100px" }, position: "absolute", left:0 }} />
                <Box sx={{marginBottom : "20px", marginLeft:{xs:"70px", md:0}}}>
                    <Typography component="h1" sx={{textAlign:"center",  lineHeight:"25px", fontSize:{xs:15, md:20}, fontWeight:"bold"}}>Outil de management des SAV</Typography>
                </Box>
            </Box>
            <FormulaireTicket admin={false}/>
        </Container>
    )
}